import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import about from './about/contact';


export default new Vuex.Store({
  modules: {
    about,
  }
});
